/**
 * 
 */
export const Checkbox = function () {
	const sessionStorageKey = "choosedTotal"; // Key of session Storage
	if (storageAvailable("sessionStorage")) {
		const total = window.sessionStorage.getItem(sessionStorageKey); // get current value
		if (total > 0 && document.getElementById("result_total")!==null) { // display the value
			document.getElementById("result_total").innerText = total;
		}
		if (window.location.search.indexOf("mode")<0) { // no url params: set 0
			window.sessionStorage.setItem(sessionStorageKey, 0);
		}
	}

	// set Total count
	const setTotal = function (checkboxes) {
		let total = 0;
		const result = document.getElementById("result_total");
		if (result && checkboxes.length > 0) {
			checkboxes.forEach((label) => {
				const checkbox = label.querySelector("input[type='checkbox']");
				const number = label.querySelector(".is-checkbox").dataset.number;
				const checked = checkbox.checked;
				if (checkbox && number !== "" && checked) {
					total += Number(number);
				}
			});
			// console.log(total);
			if (total > 0) {
				result.innerText = total;
				if (storageAvailable("sessionStorage")) {
					window.sessionStorage.setItem(sessionStorageKey, total);
				}
			}
		}
	}

	// set checked event
	const checkboxes = document.querySelectorAll(".is-option");
	if (checkboxes.length > 0) {
		checkboxes.forEach((box) => {
			const checkbox = box.querySelector("input[type='checkbox']");
			const number = box.querySelector(".is-checkbox").dataset.number;
			if (number === "") {
				box.style.display = "none";
			}
			if (checkbox) {
				checkbox.addEventListener("change", (elm) => {
					// change appearance
					const target = elm.target;
					const checked = target.checked;
					if (checked) {
						box.classList.add("checked");
					} else {
						box.classList.remove("checked");
					}
					setTotal(checkboxes);
					duplicateChecks();
				});
			}
		});
	}

	const duplicateChecks = function () {
		const moreOptions = document.getElementById("more_options");
		const checkboxes = document.querySelectorAll("input[form='show_result']");
		if (checkboxes.length > 0 && moreOptions) {
			moreOptions.innerHTML = "";
			checkboxes.forEach((checkbox) => {
				if (checkbox.checked) {
					const clone = checkbox.cloneNode(true);
					clone.style.display = "none";
					clone.checked = true;
					clone.removeAttribute("form");
					// console.log(clone);
					moreOptions.appendChild(clone);
				}
			});
		}
	}

	// set choosed again
	const choosed = document.getElementById("choosed-options");
	if (choosed) {
		const options = choosed.innerText.replace(/\s+/g, '').split(",");
		const checkboxes = document.querySelectorAll("input[type='checkbox']");
		if (checkboxes.length > 0) {
			checkboxes.forEach((checkbox) => {
				const check = options.includes(checkbox.value);
				if (check) {
					checkbox.checked = true;
				}
			});
		}
		setTotal(document.querySelectorAll(".is-option"));
		duplicateChecks();
	}

	// Check local storage available
	function storageAvailable(type) {
		let storage;
		try {
			storage = window[type];
			const x = "__storage_test__";
			storage.setItem(x, x);
			storage.removeItem(x);
			return true;
		} catch (e) {
			return (
				e instanceof DOMException &&
				// everything except Firefox
				(e.code === 22 ||
					// Firefox
					e.code === 1014 ||
					// test name field too, because code might not be present
					// everything except Firefox
					e.name === "QuotaExceededError" ||
					// Firefox
					e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
				// acknowledge QuotaExceededError only if there's something already stored
				storage &&
				storage.length !== 0
			);
		}
	}
}
